
import React from 'react';
import { 
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
  DialogFooter
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { AlertCircle } from "lucide-react";
import { Card, CardContent } from "@/components/ui/card";

interface PaymentBreakdownDialogProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  totalAmount: number;
}

const PaymentBreakdownDialog: React.FC<PaymentBreakdownDialogProps> = ({
  isOpen,
  onClose,
  onConfirm,
  totalAmount
}) => {
  const initialPayment = totalAmount * 0.7;
  const remainingPayment = totalAmount * 0.3;

  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            <AlertCircle className="h-5 w-5 text-primary" />
            Szczegóły płatności
          </DialogTitle>
          <DialogDescription>
            Twoje zamówienie zostanie podzielone na dwie płatności
          </DialogDescription>
        </DialogHeader>
        
        <div className="space-y-4 py-4">
          <Card className="border-2 border-primary/10">
            <CardContent className="pt-6">
              <h3 className="text-center font-medium text-lg mb-4">Struktura płatności</h3>
              <div className="space-y-3">
                <div className="flex justify-between items-center pb-2 border-b">
                  <span className="font-medium">Pierwsza płatność (teraz):</span>
                  <span className="text-primary font-semibold">{initialPayment.toFixed(2)} zł</span>
                </div>
                <div className="flex justify-between items-center pb-2 border-b">
                  <span className="font-medium">Druga płatność (po montażu):</span>
                  <span className="text-primary font-semibold">{remainingPayment.toFixed(2)} zł</span>
                </div>
                <div className="flex justify-between items-center pt-2">
                  <span className="font-medium">Łączna wartość zamówienia:</span>
                  <span className="text-primary font-semibold">{totalAmount.toFixed(2)} zł</span>
                </div>
              </div>
            </CardContent>
          </Card>

          <div className="text-sm text-gray-500">
            <p>• Pierwsza płatność (70%) jest wymagana teraz, aby zarezerwować termin montażu.</p>
            <p>• Druga płatność (30%) będzie wymagana po zakończeniu montażu.</p>
            <p>• Informacje o drugiej płatności zostaną przesłane po zakończeniu instalacji.</p>
          </div>
        </div>

        <DialogFooter className="sm:justify-between">
          <Button variant="outline" onClick={onClose}>
            Wróć
          </Button>
          <Button onClick={onConfirm} className="bg-primary hover:bg-primary-dark">
            Kontynuuj do płatności
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default PaymentBreakdownDialog;
